import React from 'react';
import { useNavigate } from 'react-router-dom';

// Help searches and one-off lookups -- same card hub as Control Panel, but for
// tools that answer a question rather than change a setting.
const CARDS = [
  {
    path:        '/utilities/po-match-search',
    icon:        '🔍',
    title:       'PO Match Search',
    description: 'Enter an order PO and find newer received POs from the same supplier that match it, scored by % of matching item codes.',
    accent:      'blue',
  },
  {
    path:        '/hot-back-orders',
    icon:        '⏳',
    title:       'HOT Back Orders',
    description: "Items HOT has on backorder for us — Cin7 code, PO and the customer orders waiting on each.",
    accent:      'blue',
  },
  {
    path:        '/margin-watch',
    icon:        '📉',
    title:       'Margin Watch',
    description: 'Sales order items in Warehouse Transfer with gross profit below 30% — worst first.',
    accent:      'red',
  },
  {
    path:        '/margin-check',
    icon:        '🧮',
    title:       'Margin Check',
    description: 'Look up all pricing and margins for a purchase order or a single item code.',
    accent:      'blue',
  },
  {
    path:        '/product-error-management',
    icon:        '🔧',
    title:       'Product Error Management',
    description: 'Order item codes with no matching product_options entry — mark fixed or ignored.',
    accent:      'red',
  },
  {
    path:        '/data-sweep',
    icon:        '🧹',
    title:       'Data Sweep',
    description: 'Anomalies picked up by the scheduled data checks — starting with open POs that duplicate an already-received supplier invoice.',
    accent:      'gold',
  },
  {
    path:        '/knowledge-nuggets',
    icon:        '🧠',
    title:       'Knowledge Nuggets',
    description: 'Review staff advice captured from recorded conversations — approve, fix or reject it, and mark what is safe to tell customers.',
    accent:      'gold',
  },
  {
    path:        '/bench-clips',
    icon:        '🎬',
    title:       'Bench Clips',
    description: 'Draft video clips of hands-on work at the repair bench, picked each night — keep the good ones, discard the rest.',
    accent:      'gold',
  },
  {
    path:        '/help',
    icon:        '📖',
    title:       'Help & Process Guides',
    description: 'How the automated processes work behind the scenes, and where your part starts.',
    accent:      'blue',
  },
  {
    path:        '/supplier-spend',
    icon:        '💰',
    title:       'Supplier Spend',
    description: 'Current month purchase order spend by supplier — select suppliers to total them up.',
    accent:      'gold',
  },
  {
    path:        '/todo-list',
    icon:        '📝',
    title:       'To-Do List',
    description: 'Shared team to-do list — assign an owner and a due date, tick items off as they are done.',
    accent:      'blue',
  },
  {
    path:        '/backorder-management',
    icon:        '📥',
    title:       'Back Order Management',
    description: 'Sales orders at HC - Back Order — action and log notes, same worklist as Problem Encountered.',
    accent:      'blue',
  },
  {
    path:        '/digital-metrics',
    icon:        '📈',
    title:       'Digital Metrics',
    description: 'Weekly traffic-light health report on the website and social channel, plus the critical error log.',
    accent:      'green',
  },
];

const Utilities = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/')}>← Home</button>
        <span className="page-nav__title">Utilities</span>
      </div>

      <div className="home-greeting">
        <p className="home-greeting__sub">Select a function to get started</p>
      </div>
      <div className="home-cards">
        {CARDS.map((card) => (
          <button
            key={card.path}
            className={`home-card home-card--${card.accent}`}
            onClick={() => navigate(card.path)}
          >
            <div className="home-card__icon">{card.icon}</div>
            <div className="home-card__body">
              <div className="home-card__title">{card.title}</div>
              <div className="home-card__desc">{card.description}</div>
            </div>
            <div className="home-card__arrow">→</div>
          </button>
        ))}
      </div>
    </main>
  );
};

export default Utilities;
